import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface DeliveryPlanningTemplate {
    id: number;
    deliveryPlanningTemplateName: string;
}

export async function getDeliveryPlanningTemplate(id: number): Promise<DeliveryPlanningTemplate> {
    return legacyFetch<DeliveryPlanningTemplate>(`deliveryplanningtemplate/${id}`);
}

export async function createDeliveryPlanningTemplate(t: Partial<DeliveryPlanningTemplate>): Promise<DeliveryPlanningTemplate> {
    return legacyFetch<DeliveryPlanningTemplate>('deliveryplanningtemplate', {
        method: 'POST',
        body: JSON.stringify(t),
    });
}

export async function updateDeliveryPlanningTemplate(t: DeliveryPlanningTemplate): Promise<DeliveryPlanningTemplate> {
    return legacyFetch<DeliveryPlanningTemplate>(`deliveryplanningtemplate/${t.id}`, {
        method: 'PUT',
        body: JSON.stringify(t),
    });
}
